'use client';
import { memo } from 'react';
import { Grid, Text, VStack } from '@chakra-ui/react';

import ContactForm from 'features/ContactForm';
import BlockHeader from 'shared/BlockHeader';
import { HelperStep } from './ui';

import { FORM_ID } from 'constants/global';
import { defaultDescription, defaultTitle } from 'constants/ContactUs';
import { defaultSchema, fieldsData, helpers } from 'constants/ContactForm';

const ContactUs = ({
  title = null,
  titleProps = null,
  description = defaultDescription,
  descriptionProps = null,
  validationSchema = defaultSchema,
  placeholders = fieldsData,
  helpersForm = helpers,
  metricNameOnFormSubmit = null,
  helperStepSameStyle = null,
  gridProps = null,
}) => (
  <VStack
    as="section"
    w="full"
    gap={{ mobile: '24px', tablet: '32px', laptop: '48px', desktop: '40px' }}
  >
    <VStack w="full" gap={{ mobile: '16px', laptop: '20px', desktop: '16px' }} align="start">
      <BlockHeader id={FORM_ID} {...titleProps}>
        {title ?? defaultTitle}
      </BlockHeader>

      <Text
        textStyle="h1"
        maxW={{ desktop: '770px', laptop: '625px', tablet: '496px' }}
        {...descriptionProps}
      >
        {description}
      </Text>
    </VStack>

    <VStack w="full" gap={{ mobile: '16px', laptop: '20px' }}>
      <ContactForm
        validationSchema={validationSchema}
        placeholders={placeholders}
        metricNameOnFormSubmit={metricNameOnFormSubmit}
      />

      <Grid
        w="full"
        templateColumns={{ mobile: '1fr', tablet: 'repeat(2, 1fr)', laptop: 'repeat(4, 1fr)' }}
        templateRows={{ tablet: 'minmax(165px, 1fr)', laptop: 'minmax(290px, 1fr)' }}
        gap={{ mobile: '8px', tablet: '16px', laptop: '20px' }}
        hideBelow="tablet"
        {...gridProps}
      >
        {helpersForm?.map((val, i) => (
          <HelperStep
            key={i}
            index={i + 1}
            {...val}
            {...helperStepSameStyle}
            descriptionSx={{
              maxW: { desktop: '241px' },
              fontSize: { mobile: '12px', laptop: '16px' },
            }}
          />
        ))}
      </Grid>
    </VStack>
  </VStack>
);

export default memo(ContactUs);
